var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58337 5.00004C8.99289 5.00004 8.44763 5.20223 8.06331 5.53165C7.68295 5.85767 7.50004 6.26978 7.50004 6.66671C7.50004 7.12694 7.12694 7.50004 6.66671 7.50004C6.20647 7.50004 5.83337 7.12694 5.83337 6.66671C5.83337 5.73755 6.26504 4.87789 6.97865 4.26623C7.68829 3.65796 8.62676 3.33337 9.58337 3.33337H10.4167C11.3733 3.33337 12.3118 3.65796 13.0214 4.26623C13.7289 4.87266 14.1593 5.72286 14.1666 6.64286C14.2021 7.35633 14.0074 8.06256 13.6109 8.65727C13.2193 9.24461 12.6517 9.69211 11.9902 9.93593C11.6894 10.0867 11.387 10.3835 11.1613 10.835C10.9285 11.3004 10.8075 11.8737 10.8326 12.4646C10.8522 12.9244 10.4953 13.3131 10.0355 13.3326C9.57564 13.3522 9.18702 12.9953 9.16746 12.5355C9.13123 11.6836 9.30207 10.8266 9.67055 10.0896C10.0384 9.35384 10.6012 8.7459 11.3129 8.41219C11.3382 8.40036 11.364 8.3898 11.3903 8.38056C11.7311 8.26072 12.0237 8.03337 12.2241 7.73277C12.4245 7.43217 12.5218 7.07459 12.5014 6.7139C12.5005 6.69818 12.5 6.68245 12.5 6.66671C12.5 6.26978 12.3171 5.85767 11.9368 5.53165C11.5525 5.20223 11.0072 5.00004 10.4167 5.00004H9.58337ZM10 15C10.4603 15 10.8334 15.3731 10.8334 15.8334V15.8417C10.8334 16.3019 10.4603 16.675 10 16.675C9.5398 16.675 9.16671 16.3019 9.16671 15.8417V15.8334C9.16671 15.3731 9.5398 15 10 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.da1043bee8c2b320d7ebc7b1b6196b46.svg";
export { ForwardRef as ReactComponent };